import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, unref as _unref, resolveComponent as _resolveComponent, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

import Navigation from "@/components/Navigation/index.vue";
import { computed, onBeforeMount } from "vue";
import store from "@/store";
import Bootstrap from "@/composables/BootStrap";

export default /*#__PURE__*/_defineComponent({
  __name: 'WithNav',
  setup(__props) {

onBeforeMount(async () => {
  await Bootstrap();
});

const isLoading = computed(() => store.getters["app/isLoading"]);

return (_ctx: any,_cache: any) => {
  const _component_router_view = _resolveComponent("router-view")!
  const _component_p_toast = _resolveComponent("p-toast")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(Navigation),
    _createElementVNode("section", {
      class: _normalizeClass(["max-w-screen-lg mx-auto px-2", { 'pointer-events-none opacity-50': _unref(isLoading) }])
    }, [
      _createVNode(_component_router_view)
    ], 2),
    _createVNode(_component_p_toast)
  ], 64))
}
}

})